export default __webpack_public_path__ + "static/media/twitter.82b6399b.svg";